/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type GetWhitelistsQuery = {
    format: GetWhitelistsQuery.format;
    lastSequenceNumber?: number;
    tokenAlgorId?: number;
    /**
     * Currently not in use. For future use
     */
    test?: boolean;
};
export namespace GetWhitelistsQuery {
    export enum format {
        ABSOLUTE = 'Absolute',
        DELTA = 'Delta',
        ABSOLUTE_WITHOUT_PERSONAL_DATA = 'AbsoluteWithoutPersonalData',
        '_1' = 1,
        '_2' = 2,
        '_3' = 3,
    }
}

